// extracted by mini-css-extract-plugin
export default {"TableContainer":"PurchaseIntentList_TableContainer__lNhiP","Menu":"PurchaseIntentList_Menu__AiODv","FormItem":"PurchaseIntentList_FormItem__uSXgS"};